// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3G48k","title":"Header_title__1ry1G","left":"Header_left__1tzaa","clinicName":"Header_clinicName__3Sx0j"};